import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/store";
import Seo from "../components/Seo";
import NotFound from "./NotFound";

export default function DynamicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(undefined);
  useEffect(() => {
    let ok = true;
    axios.get(`${API}/pages/${slug}`).then((r) => ok && setPage(r.data)).catch(() => ok && setPage(null));
    return () => { ok = false; };
  }, [slug]);

  if (page === undefined) return <div className="min-h-[50vh]" />;
  if (page === null) return <NotFound />;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 pt-12 pb-8" data-testid="dynamic-page">
      <Seo title={page.seoTitle || page.title} description={page.seoDescription} path={`/p/${slug}`} />
      <h1 className="section-title text-center">{page.title}</h1>
      {page.image && <img src={page.image} alt={page.title} className="w-full max-h-[420px] object-cover border border-[#eee6d6] mt-6" />}
      <div
        className="mt-8 text-[#5c5240] leading-relaxed"
        style={{ whiteSpace: "pre-line" }}
        dangerouslySetInnerHTML={{ __html: page.bodyHtml || "" }}
      />
    </div>
  );
}
